import { useStateContext } from '../contexts/ContextProvider';
import { hasPermission, getRoleDescription } from '../config/permissions';

export const usePermissions = () => {
  const { user } = useStateContext();
  
  const checkPermission = (requiredRoles) => {
    if (!user || !user.role_id) return false;
    return hasPermission(user.role_id, requiredRoles);
  };
  
  const getUserRole = () => {
    return user?.role_id || null;
  };
  
  const getUserRoleDescription = () => {
    return user?.role_id ? getRoleDescription(user.role_id) : 'Utilizator neautentificat';
  };
  
  const isAdmin = () => checkPermission([1]);
  const isManager = () => checkPermission([2]);
  const isContabil = () => checkPermission([3]);
  const isLogistic = () => checkPermission([4]);
  
  return {
    checkPermission,
    getUserRole,
    getUserRoleDescription,
    isAdmin,
    isManager,
    isContabil,
    isLogistic,
    user
  };
}; 